import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, configure, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import nl from 'vee-validate/dist/locale/nl.json';
import { required, min, ext } from 'vee-validate/dist/rules';
import moment from 'moment';
import VModal from 'vue-js-modal';
import { Plugin } from 'vue-fragment';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import * as setup from './scripts/setup';

/** Import component styles */
import './scss/components.scss';

/** Set momentjs locale */
moment.locale(document.documentElement.lang);

/** Initialize plugins */
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(Plugin);
Vue.use(VueLodash, { lodash: lodash })

/** Initialize rules */
extend('required', required);
extend('min', min);
extend('ext', ext);

configure({
    classes: {
        invalid: 'has-error'
    }
});

localize({
    en,
    nl
});

localize(document.documentElement.lang);

/** Initialize components */
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

/** Import required site components */
import './scripts/components/servicepoints/servicepointedit';
import './scripts/components/orders/detail/orderDetail';
import './scripts/components/orders/overview/orderoverview';
import './scripts/components/navigation/shortcuts';
import './scripts/components/contracts/contractDetail';
import './scripts/components/contracts/contractOverview';
import './scripts/components/statements/statementQuestions';
import './scripts/components/statements/statementFileOverview';

setup.initializeVue();
setup.initializeVueComponents();